<nz-modal
  [nzVisible]="isVisible()"
  [nzTitle]="undefined"
  [nzFooter]="null"
  nzCentered
  nzWrapClassName="system-status-modal__popup"
  nzWidth="fit-content">
  <ng-container *nzModalContent>
    <div class="system-status-modal__wrapper">
      <h2 class="system-status-modal__title">We'll be right back</h2>
      <p class="system-status-modal__description">
        Our system is temporarily unavailable. We’re working to resolve the
        issue, and you’ll be able to continue once service is restored.
      </p>
      <img
        class="system-status-modal__image"
        src="/assets/images/system-down.png"
        alt="System Down Image" />
    </div>
  </ng-container>
</nz-modal>
